export class DrillDownConfig {
    constructor(
        public isDrillDown = false,
        public isDrillUp = false,
        public parentId = "",
        public parentName = ""
    ) { }
}